import reject from 'lodash/fp/reject';
import { BAY_AREA, BAY_AREA_CITIES, NO_GREASE_CONCORD_SHOP } from './constants';

const fetchCities = cities => [BAY_AREA, ...cities];

const fetchShops = (clearShops, fetchAction) => ({ city, ...args }) => (dispatch) => {
  dispatch(clearShops());
  if (city !== BAY_AREA) return dispatch(fetchAction({ city, ...args }, false));
  const filterShops = reject({ id: NO_GREASE_CONCORD_SHOP });
  const actions = BAY_AREA_CITIES.map(item => dispatch(fetchAction({ city: item, ...args }, false, filterShops)));
  return Promise.all(actions);
};

export default {
  fetchCities,
  fetchShops,
};



// WEBPACK FOOTER //
// ./src/app/applicationServices/bayAreaShops/index.js